import React from 'react';
import { useParams } from 'react-router-dom';
import useLeaveService from 'domain/people/leave/shared/leaveService';
import { useLeaveUrl } from 'domain/people/leave/leaveRouting';
import { DeleteButton } from 'framework/ui/ui-builder';
import { LEAVE_CANCEL } from 'domain/shared/leave';

const rejectLeaveMessage = 'Are you sure you want to cancel this leave request? This action cannot be undone.';

const RejectLeaveButton = (props: any) => {
  const { id: leaveId } = useParams<Dictionary<string>>();
  const { rejectById } = useLeaveService();
  const { getListUrl } = useLeaveUrl();

  return (
    <DeleteButton
      deleteMethod={() => rejectById(leaveId!)}
      buttonText="Cancel request"
      displayMessage={rejectLeaveMessage}
      permissionToCheck={LEAVE_CANCEL}
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The Leave request will be canceled. It may take up to 2 days.',
        errorMessage: 'This Leave request cannot be canceled.',
      }}
      {...props}
    />
  );
};

export default RejectLeaveButton;
